<template>
  <div class="flex items-center justify-end gap-x-2">
    <div
      data-cy="show-less"
      class="flex h-6 cursor-pointer items-center justify-center rounded-full bg-dim-grey px-3 text-xs text-white"
      @click="emit('collapse')"
    >
      {{ $t("COMMON.SHOW_LESS") }}
    </div>
    <div
      data-cy="scrolling-close"
      class="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-dim-grey"
    >
      <icon-base
        :icon="IconClose"
        width="12"
        height="12"
        view-box="0 0 18 18"
        @click.stop="emit('close')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconClose from "@/components/icons/IconClose.vue";

const emit = defineEmits<{
  collapse: [];
  close: [];
}>();
</script>
